"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadImage = void 0;
function loadImage(src) {
    return new Promise(function (resolve, reject) {
        var image = new Image();
        image.onload = function () { return resolve(); };
        image.onerror = function (error) { return reject(error); };
        image.src = src;
    });
}
exports.loadImage = loadImage;
//# sourceMappingURL=loadImage.js.map